import { render, staticRenderFns } from "./DashboardRoot.vue?vue&type=template&id=4c6c0abd"
import script from "./DashboardRoot.vue?vue&type=script&lang=ts"
export * from "./DashboardRoot.vue?vue&type=script&lang=ts"
import style0 from "./DashboardRoot.vue?vue&type=style&index=0&id=4c6c0abd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports